<template>
    <form role="form">

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">Beschreibung des Imports</label>
            <div class="col-md-6">
                <input :disabled="this.formdisabled" type="text" class="form-control" name="desc" v-model="form.desc">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">Import-Vorlage</label>
            <div class="col-md-6">
                <kendo-datasource ref="importTemplateDatasource"
                                  :transport-read-url="'/api/import/templates'">
                </kendo-datasource>
                <kendo-dropdownlist ref="importTemplateDropdown"
                                    v-model="form.importTemplate"
                                    :data-source-ref="'importTemplateDatasource'"
                                    :data-text-field="'name'"
                                    :data-value-field="'id'"
                                    :filter="'contains'"
                                    :disabled="this.formdisabled"
                                    :option-label="'Bitte wählen...'">
                </kendo-dropdownlist>
            </div>
        </div>


        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">Excel-Datei</label>

            <div class="col-md-6">
                <kendo-upload ref="uploadFile"
                              name="uploadFile"
                              @upload="onSaveFile"
                              @success="onSaveFileSuccess"
                              @complete="onSaveFileComplete"
                              @error="onSaveFileError"
                              :multiple="false"
                              :async-save-url="'/api/import/save-file'"
                              :async-remove-url="'/api/import/remove-file'"
                              :async-with-credentials="true"
                >
                </kendo-upload>
            </div>
        </div>


        <div class="form-group row mb-0">
            <div class="col-md-6 offset-md-4">
                <button type="submit" class="btn btn-primary"
                        :disabled = "!(form.tmpFile.error == 0 && form.desc  != '' && form.importTemplate != '')"
                        @click.prevent="startProcess">
                    Daten importieren
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "import-excel",
        data: function() {
            return {
                formdisabled: false,
                form:{
                    desc: "",
                    importTemplate: "",
                    tmpFile: ""
                }
            }
        },
        mounted: function() {
            this.init();
        },
        methods: {
            init: function() {
                console.log('init import-excel');
            },
            startProcess: function(){
                console.log('start process');
                console.log(this.form);
                this.performImport();
            },

            performImport:function(){
                axios.post('/api/import/perform-import', {
                    form: this.form
                })
                    .then(function (response) {
                        console.log("response",response);
                    })
                    .catch(function (error) {
                        console.log("error",error);
                    });
            },


            onSaveFile:function(e){
                console.log("onSaveFile",e);
                var xhr = e.XMLHttpRequest;
                console.log("xhr",xhr);
                if (xhr) {
                    xhr.addEventListener("readystatechange", function (e) {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
                            xhr.setRequestHeader("X-XSRF-TOKEN", $('meta[name="xsrf-token"]').attr('content'));
                        }
                    });
                }
            },

            onSaveFileSuccess:function(e){
                console.log("Save File success:",e);
                if(e.response.error == 0){
                    this.form.tmpFile = e.response;
                }
            },

            onSaveFileComplete:function(e){
                console.log("Save File complete:",e);
            },

            onSaveFileError:function(e){
                console.log("Save File Error:",e);
            },
        }

    }
</script>

<style scoped>
</style>
